import Base from './Base';

class PaymentsControl extends Base {

    constructor () {
        super();
        this.endpoint = 'payments-control';
    }

    getIds( ids ) {
        return  fetch(this.getUrlEndpoint("get/ids/"+ids),{
            method: 'GET',
            headers: this.headers
        }).then( response => response.json() )
    }

    getContract( user_id ) {
        return  fetch(this.getUrlEndpoint("get-contract/"+user_id),{
            method: 'GET',
            headers: this.headers
        }).then( response => response.json() )
    }

    getAdeudosCliente( user_id ) {
        return  fetch(this.getUrlEndpoint("get-adeudos/"+user_id),{
            method: 'GET',
            headers: this.headers
        }).then( response => response.json() )
    }

    updatePaymentControl( id, data ) {
        return  fetch(this.getUrlEndpoint("update/"+id),{
            method: 'PATCH',
            headers: this.headers,
            body: JSON.stringify(data)
        }).then( response => response.json() )
    }

    activateContract( id, data ) {
        return  fetch(this.getUrlEndpoint("activate-contract/"+id),{
            method: 'POST',
            headers: this.headers,
            body: JSON.stringify(data)
        }).then( response => response.json() )
    }

    updateWithConcepts( id, data ) {
        return  fetch(this.getUrlEndpoint("updateFull/"+id),{
            method: 'PATCH',
            headers: this.headers,
            body: JSON.stringify(data)
        }).then( response => response.json() )
    }
    

    updateContract( id, data ) {
        return  fetch(this.getUrlEndpoint("update-contract/"+id),{
            method: 'PATCH',
            headers: this.headers,
            body: JSON.stringify(data)
        }).then( response => response.json() )
    }

    sendAdeudo( user_id, data ) {
        return  fetch(this.getUrlEndpoint("send-adeudo/"+user_id),{
            method: 'POST',
            headers: this.headers,
            body: JSON.stringify(data)
        }).then( response => response.json() )
    }
    
    
}

export default PaymentsControl;